// Generated by purs version 0.15.0
import * as Control_Applicative from "../Control.Applicative/index.js";
import * as Control_Bind from "../Control.Bind/index.js";
import * as Control_Category from "../Control.Category/index.js";
import * as Data_Foldable from "../Data.Foldable/index.js";
import * as Data_Functor from "../Data.Functor/index.js";
import * as Data_Unit from "../Data.Unit/index.js";
import * as Effect from "../Effect/index.js";
import * as Effect_Class from "../Effect.Class/index.js";
import * as Specular_Dom_Builder_Class from "../Specular.Dom.Builder.Class/index.js";
import * as Specular_FRP_Base from "../Specular.FRP.Base/index.js";
var triggerCallback = /* #__PURE__ */ Control_Category.identity(Control_Category.categoryFn);
var nullCallback = function (v) {
    return Control_Applicative.pure(Effect.applicativeEffect)(Data_Unit.unit);
};
var newCallback = function (dictMonadEffect) {
    return Data_Functor.map((((dictMonadEffect.Monad0()).Bind1()).Apply0()).Functor0())(function (v) {
        return {
            event: v.event,
            callback: v.fire
        };
    })(Specular_FRP_Base.newEvent(dictMonadEffect));
};
var mkCallback = /* #__PURE__ */ Control_Category.identity(Control_Category.categoryFn);
var mbCallback = /* #__PURE__ */ Data_Foldable.traverse_(Effect.applicativeEffect)(Data_Foldable.foldableMaybe);
var dynCallback = function (dynCb) {
    return function (x) {
        return function __do() {
            var cb = Specular_FRP_Base.readDynamic(Effect_Class.monadEffectEffect)(dynCb)();
            return cb(x)();
        };
    };
};
var contramapCallbackEffect = function (f) {
    return function (cb) {
        return Control_Bind.composeKleisli(Effect.bindEffect)(f)(cb);
    };
};
var contramapCallbackDyn_ = function (fD) {
    return function (cb) {
        return function (v) {
            return function __do() {
                var f = Specular_FRP_Base.readDynamic(Effect_Class.monadEffectEffect)(fD)();
                return cb(f)();
            };
        };
    };
};
var contramapCallbackDynMaybe = function (fD) {
    return function (cb) {
        return function (x) {
            return function __do() {
                var f = Specular_FRP_Base.readDynamic(Effect_Class.monadEffectEffect)(fD)();
                return Data_Foldable.traverse_(Effect.applicativeEffect)(Data_Foldable.foldableMaybe)(cb)(f(x))();
            };
        };
    };
};
var contramapCallbackDyn = function (fD) {
    return function (cb) {
        return function (x) {
            return function __do() {
                var f = Specular_FRP_Base.readDynamic(Effect_Class.monadEffectEffect)(fD)();
                return cb(f(x))();
            };
        };
    };
};
var attachEvent = function (dictMonadFRP) {
    return function (event) {
        return function (cb) {
            return Specular_FRP_Base.subscribeEvent_(dictMonadFRP.MonadEffect0())(dictMonadFRP.MonadCleanup1())(cb)(event);
        };
    };
};
var attachDyn = function (dictMonadFRP) {
    return function (dyn) {
        return function (cb) {
            return Specular_FRP_Base.subscribeDyn_(dictMonadFRP)(cb)(dyn);
        };
    };
};
var attachDomEvent = function (dictMonadFRP) {
    return function (eventType) {
        return function (node) {
            return function (callback) {
                return Control_Bind.bind(((dictMonadFRP.MonadCleanup1()).Monad0()).Bind1())(Specular_Dom_Builder_Class.domEventWithSample(dictMonadFRP)(Control_Applicative.pure(Effect.applicativeEffect))(eventType)(node))(function (event) {
                    return attachEvent(dictMonadFRP)(event)(callback);
                });
            };
        };
    };
};
export {
    newCallback,
    attachEvent,
    attachDomEvent,
    attachDyn,
    contramapCallbackDyn,
    contramapCallbackDyn_,
    contramapCallbackDynMaybe,
    contramapCallbackEffect,
    nullCallback,
    dynCallback,
    mbCallback,
    mkCallback,
    triggerCallback
};
//# sourceMappingURL=index.js.map
